@if (projectData) {
  <div class="dialogContainer">
    <div class="dialogHeader">
      <img
        class="closeButton"
        src="/images/closeIconWithoutBox.png"
        (click)="closeDialog()"
        />
      </div>
      <div class="dialogContent">
        <div>
          <div class="dialogContent">
            <app-dialog-input-title
              title="Kunde"
              [required]="true"
            ></app-dialog-input-title>
            <select class="dropdown" [(ngModel)]="projectData.customerId">
              <option value="0" class="hidden">Vælg kunde</option>
              @for (customer of customers; track customer) {
                <option [value]="customer.id">
                  {{ customer.name }}
                </option>
              }
            </select>
          </div>
          <div>
            <div class="dialogContent">
              <app-dialog-input-title
                title="Projekt navn"
                [required]="true"
              ></app-dialog-input-title>
              <input type="text" class="Textbox" [(ngModel)]="projectData.name" />
            </div>
            <div>
              <div class="dialogContent">
                <app-dialog-input-title
                  title="Projekt nummer"
                  [required]="true"
                ></app-dialog-input-title>
                <input
                  type="text"
                  class="Textbox"
                  [(ngModel)]="projectData.latisNum"
                  />
                </div>
                <div>
                  <div class="dialogContent">
                    <app-dialog-input-title
                      title="Projektleder"
                    ></app-dialog-input-title>
                    <select
                      class="dialogDropdown"
                      [(ngModel)]="projectData.projectManagerId"
                      >
                      <option value="0">Evt. vælg projektleder</option>
                      @for (user of users; track user) {
                        <option [value]="user.id">
                          {{ user.name }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="dialogContent">
                    <app-dialog-input-title title="Lukket"></app-dialog-input-title>
                    <mat-form-field (click)="picker.open()">
                      <mat-label>Vælg dato</mat-label>
                      <input matInput
                        [matDatepicker]="picker"
                        [(ngModel)]="projectData.closedDate"
                        name="closedDate" />
                        <mat-datepicker-toggle matSuffix
                        [for]="picker"></mat-datepicker-toggle>
                        @if (projectData.closedDate) {
                          <button matSuffix mat-icon-button (click)="clearDate($event)">
                            <mat-icon>close</mat-icon>
                          </button>
                        }
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="dialogFooter">
                    <app-save-button
              [disabled]="
                !projectData.customerId ||
                !projectData.name ||
                !projectData.latisNum
              "
                      [clickEvent]="saveChanges.bind(this)"
                      >
                    </app-save-button>
                    @if (
                      userService.getSelectedRole ==
                      userService.getUserRoleTypes.Admin
                      ) {
                      <app-delete-button
                        [clickEvent]="deleteProject.bind(this)"
                        >
                      </app-delete-button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
